import { render, staticRenderFns } from "./InviteButton.vue?vue&type=template&id=25c31c52&scoped=true"
import script from "./InviteButton.vue?vue&type=script&lang=ts"
export * from "./InviteButton.vue?vue&type=script&lang=ts"
import style0 from "./InviteButton.vue?vue&type=style&index=0&id=25c31c52&prod&lang=scss&scoped=true"
import style1 from "./InviteButton.vue?vue&type=style&index=1&id=25c31c52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c31c52",
  null
  
)

export default component.exports